import { BeBox, BeGrid, BeText } from "@beos-css/react/index.ts";
import { usePixelSnapGrid } from "../hooks/usePixelSnapGrid";

export function Intro() {
	// snap the card grid to integer column widths so 11px pixel text stays crisp
	const navRef = usePixelSnapGrid<HTMLElement>({ min: 260, gap: 16 });
	return (
		<section id="demo-intro">
			<h1 hidden>Intro</h1>
			<h2>Intro / Other pages</h2>
			<p>Standalone demos and tools that live on their own pages, outside this component gallery.</p>
			<BeGrid as="nav" min={16} ref={navRef}>
				<BeBox href="/kanban_ui">
					<BeText face="tab">Kanban Board</BeText>
					<BeText ink="secondary">A full-featured kanban board built with BeOS UI controls.</BeText>
				</BeBox>
				<BeBox href="/cortex">
					<BeText face="tab">Cortex media router</BeText>
					<BeText ink="secondary">
						The Cortex MediaRoutingView patchbay, rasterised on a canvas at native R5 pixels (pixel-art crisp at any zoom).
					</BeText>
				</BeBox>
				<BeBox href="/cortex-dom">
					<BeText face="tab">Cortex router (DOM/SVG)</BeText>
					<BeText ink="secondary">
						The same patchbay as real DOM nodes + SVG cables -- individually addressable, accessible elements.
					</BeText>
				</BeBox>
				<BeBox href="/component_editor">
					<BeText face="tab">Component builder</BeText>
					<BeText ink="secondary">An interactive editor for composing and tweaking the BeOS controls.</BeText>
				</BeBox>
				<BeBox href="/decorator">
					<BeText face="tab">BeDecorator bitmaps</BeText>
					<BeText ink="secondary">
						Raw window-decoration provenance: the mask bitmaps and the composed close/zoom buttons in every rendered state.
					</BeText>
				</BeBox>
				<BeBox href="/fonts">
					<BeText face="tab">BeOS UI fonts</BeText>
					<BeText ink="secondary">
						Compare the UI-font options against a genuine app_server render: the real Swis721 BT (bitmap strikes + the scalable TTF off the
						VM), Helvetica, and the sub-pixel-AA fringe fix.
					</BeText>
				</BeBox>
			</BeGrid>
		</section>
	);
}
